import { useEffect, useState } from "react";

type ToastTone = "error" | "success" | "info" | "warning";

const TONE_STYLES: Record<
  ToastTone,
  { bg: string; border: string; icon: string; titleColor: string }
> = {
  error: { bg: "#fef2f2", border: "#fecaca", icon: "\u2715", titleColor: "#dc2626" },
  success: { bg: "#f0fdf4", border: "#bbf7d0", icon: "\u2713", titleColor: "#16a34a" },
  info: { bg: "#eff6ff", border: "#bfdbfe", icon: "i", titleColor: "#2563eb" },
  warning: { bg: "#fffbeb", border: "#fde68a", icon: "!", titleColor: "#d97706" },
};

export function Toast({
  title,
  message,
  tone,
  onDismiss,
}: {
  title: string;
  message: string;
  tone: ToastTone;
  onDismiss: () => void;
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 300);
    }, 4000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const s = TONE_STYLES[tone];

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] pointer-events-auto" role="alert">
      <div className="px-4 pt-3">
        <button
          type="button"
          onClick={() => {
            setVisible(false);
            setTimeout(onDismiss, 300);
          }}
          className="w-full block text-left font-inherit cursor-pointer"
        >
          <div
            className="rounded-[20px] px-4 py-3.5 border shadow-[1px_1px_0px_0px_#1c1b2e] transition-all duration-300"
            style={{
              backgroundColor: s.bg,
              borderColor: s.border,
              transform: visible ? "translateY(0)" : "translateY(-7.5rem)",
              opacity: visible ? 1 : 0,
            }}
          >
            <div className="flex flex-row items-start gap-3">
              <div className="w-6 h-6 rounded-full bg-white border border-text flex items-center justify-center mt-0.5 shrink-0">
                <span className="text-text text-xs font-extrabold">{s.icon}</span>
              </div>
              <div className="flex-1 flex flex-col gap-0.5">
                <span className="text-sm font-extrabold" style={{ color: s.titleColor }}>
                  {title}
                </span>
                <span className="text-text-muted text-sm leading-5">{message}</span>
              </div>
              <span className="text-text-dim text-lg font-bold p-1 -m-1">{"\u2715"}</span>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

export function showNativeAlert(_title: string, _message: string) {}

export function showNativeConfirm(
  _title: string,
  _message: string,
  _onConfirm: () => void,
  _onCancel?: () => void,
) {}
